/**
 * This file exposes frequently used user agent methods.
 *
 * These methods are auto-imported in components and pages and can be used
 * directly in templates, <script setup> or anywhere in the Options API without
 * having to manually import them.
 */

/**
 * Checks if the user agent is likely a bot.
 *
 * @param userAgent The user agent to check.
 * @returns True if the user agent is likely a bot, false otherwise.
 *
 * @example isLikelyABot('Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36')
 */
export function isLikelyABot(userAgent?: string) {
  const botPattern = '(inspection|bot|googlebot|crawler|spider|robot|crawling)'
  const regex = new RegExp(botPattern, 'i')

  if (userAgent) {
    return regex.test(userAgent)
  }

  if (typeof navigator !== 'undefined') {
    return regex.test(window.navigator.userAgent)
  }

  return false
}
